import actions from '@/actions';

export default {
  install: (app, options) => {
    function act(args) {
      let { action } = args;

      if(actions[action]) {
        return actions[action](args);
      }
    }
    app.provide('act', act.bind(this));
  }
}
